import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Select from 'react-select';

export default function VendorAddPriceList() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
            <div className="white-bg mh-550 mar-bot50">
            <div className="vender-edit-page">
                 <div className="vender-heading">
                   <h4>Price Lists</h4>
                 </div>
                 <div className="inner-container input-text-container">
                    <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block">
                          <label>Name</label>
                          <input type="text" className="form-control-sm" placeholder="Enter Your Website" />
                      </div>
                   </div>
                   <h6>Price Per Language Pair</h6>
                   <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block flex-center">
                          <label>Select Language</label>
                          <Select classNamePrefix='cw'
                                className="global-dropdown-select"
                                defaultValue={{ label: 'Select Language' }}
                                menuShouldScrollIntoView={false}
                          />
                      </div>
                    </div>
                </div>
                <div className="add-config-block">
                   <div className="flex justify-end">
                      <button className="text-link">+ Add Another Configuration</button>
                   </div>
                   <div className="integration-accordion-list open">
                        <div className="accordion-heading flex">
                            <div className="left"><strong>Configuration 1</strong></div>
                            <div className="right">
                                <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                    <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"></circle>
                                    <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"></rect>
                                    <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"></rect>
                                </svg>
                                <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                    <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"></circle>
                                    <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"></rect>
                                </svg>
                            </div>
                        </div>
                        <div className="integration-accordion-content">
                          <div className="col-md12">
                            <div className="flex wrap-dropdown">
                              <div className="global-dropdown-block flex-center mb-0">
                                <label>Target Languages</label>
                                <Select classNamePrefix='cw'
                                    className="global-dropdown-select"
                                    defaultValue={{ label: 'Select Language' }}
                                    menuShouldScrollIntoView={false}
                                />
                                <div className="multiselect-text flex">
                                    <small>English, </small>
                                    <small>Dutch</small>
                                    <button> 4+</button>
                                </div>
                                </div>
                               </div>
                                <h6>Price Per Word</h6>
                                <div className="price-perword flex">
                                    <div className="col-md3">
                                        <label>Already Translated (100%)</label>
                                        <input type="text" className="form-control-sm" title="Already Translated" />
                                    </div>
                                    <div className="col-md3">
                                        <label>Repetitions</label>
                                        <input type="text" className="form-control-sm" title="Repetitions" />
                                    </div>
                                    <div className="col-md3">
                                        <label>Fuzzy Matches</label>
                                        <input type="text" className="form-control-sm" title="Fuzzy Matches" />
                                    </div>
                                    <div className="col-md3">
                                        <label>75%-84% Fuzzy matches </label>
                                        <input type="text" className="form-control-sm" title="75%-84% Fuzzy matches" />
                                    </div>
                                    <div className="col-md3">
                                        <label>85%-94% Fuzzy matches </label>
                                        <input type="text" className="form-control-sm" title="85%-94% Fuzzy matches" />
                                    </div>
                                    <div className="col-md3">
                                        <label>95%-99% Fuzzy matches </label>
                                        <input type="text" className="form-control-sm" title="95%-99% Fuzzy matches" />
                                    </div>
                                    <div className="col-md3">
                                        <label>New Words</label>
                                        <input type="text" className="form-control-sm" title="New Words" />
                                    </div>
                                </div>
                            </div>
                        </div>
                   </div> 
                   
                </div>
              </div>

            </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist">
        <div className="left flex">
            
        </div>
        <div className="left flex">
            <div>
            <button className="btn-default">Cancel</button>
            </div>
            <div>
            <button className="btn-default">Save</button>
            </div>
        </div>
     </div>
    </div>
  );
}
